export default {
  development: {
    // Prefer current hostname so host browser (localhost) and Docker MCP
    // (host.docker.internal) both reach local GraphQL on :8111.
    GRAPH_PUBLIC: (typeof window !== 'undefined' ? `http://${window.location.hostname}:8111/public/graphql` : 'http://localhost:8111/public/graphql'),
    GRAPH_PRIVATE: (typeof window !== 'undefined' ? `http://${window.location.hostname}:8111/user/graphql` : 'http://localhost:8111/user/graphql'),
    WEB_SERVER: (typeof window !== 'undefined' ? `http://${window.location.hostname}:3000` : 'http://localhost:3000'),
    WEB_CMS_SERVER: (typeof window !== 'undefined' ? `http://${window.location.hostname}:3001` : 'http://localhost:3001'),
    API_HOST: (typeof window !== 'undefined' ? `http://${window.location.hostname}:8111` : 'http://localhost:8111'),
    GRANT_TYPE: 'password',
    CLIENT_ID: 'MjNIa01Tb2xNVDF6cUUxUg==',
    CLIENT_SECRET: 'T3RCcHZ6VHU4OU5IYmd0eUZoS0hBdUNvNGk3ZzNGRTM=',
  },
  staging: {
    CLIENT_ID: 'RHBWNUo3WEhIcXJ4cmlDVGdyUmd0YU5reGNEWW1KTmM=',
    CLIENT_SECRET: 'NDgyNTJwRlQweXVGUW1ITWRsMTNzd01heUNodFlzdnM5RjhCYnpyeXZaZDNnRHo0TGhFc21hcGZDUUZ3MkdYUA==',
    GRANT_TYPE: 'password',
    GRAPH_PRIVATE: 'https://graph-staging.tewsbarbershop.com/user/graphql',
    GRAPH_PUBLIC: 'https://graph-staging.tewsbarbershop.com/public/graphql',
    // GRAPH_PRIVATE_WS: process.env.DSDSADSA,
    WEB_SERVER: 'https://staging.tewsbarbershop.com',
    WEB_CMS_SERVER: 'https://admin-staging.tewsbarbershop.com',
    API_HOST: '',
  },
  production: {
    CLIENT_ID: 'MjNIa01Tb2xNVDF6cUUxUg==',
    CLIENT_SECRET: 'T3RCcHZ6VHU4OU5IYmd0eUZoS0hBdUNvNGk3ZzNGRTM=',
    GRANT_TYPE: 'password',
    GRAPH_PRIVATE: 'https://graph.tewsbarbershop.com/user/graphql',
    GRAPH_PUBLIC: 'https://graph.tewsbarbershop.com/public/graphql',
    // GRAPH_PRIVATE_WS: process.env.DSDSADSA,
    WEB_SERVER: 'https://booking.tewsbarbershop.com',
    WEB_CMS_SERVER: 'https://admin.tewsbarbershop.com',
    API_HOST: '',
  },
}



// WEBPACK FOOTER //
// ./src/constants/environment.js